export default __webpack_public_path__ + "static/media/mobile_bg.f0ce9e54.jpg";